module.exports = __webpack_public_path__ + "static/img/team_honor_champion.01945947.png";